import React from 'react';

const QuickAccessNav = () => {
  return (
    <nav className="quick-access-nav" id="rmqg_quickAccessNav">
      <h1 className="hide-accessible">Thực đơn</h1>
      <ul>
        <li>
          <a href="#main-content">Truy cập nội dung luôn</a>
        </li>
      </ul>
    </nav>
  );
};

export default QuickAccessNav; 